import getBrowserInfo from './getBrowserInfo';
import getName from './getName';
import getPhone from './getPhone';
import getInhabitance from './getInhabitance';
import formatDateOfBirth from './formatDateOfBirth';
import removeEmptyFields from '../utils/removeEmptyFields';
import {
  getDateTime,
  getIdentifiers,
  getProductWithLocale,
  getCompanies,
} from './handleDataConversion';

export const formatFormDataToPSL = (submitValues, product, inAuthId, formattedArchiveData) => {
  const {
    prefix,
    title,
    firstName,
    middleName,
    lastName,
    nameOnCard,
    dateOfBirth,
    email,
    mobilePhoneNumber,
    profession,
    occupation,
    industry,
    hasSameAddress,
    nationality,
    placeOfBirth,
    streetName,
    houseNumber,
    location,
    postalCode,
    plasticColor,
  } = submitValues;

  const getSupplementaryAddress = () => (
    !hasSameAddress ? [
      removeEmptyFields({
        type: 'HOME',
        language: 'DE',
        line1: `${houseNumber} ${streetName}`,
        line2: '',
        line3: '',
        postalCode,
        city: location,
        country: '276',
      }),
    ] : null
  );

  const {
    flags: { isCompany }, cardTypeIndicators, plasticIndicators, productShortName,
  } = product;
  let applicationCategory = 'CONSUMER_CARDS';

  if (isCompany) {
    applicationCategory = 'SMALL_BUSINESS_CARDS';
  }

  return removeEmptyFields({
    journeyStage: 'PRIMARY',
    applicationCategory,
    consents: [{
      type: 'TERMS',
      isAccepted: true,
      dateTime: getDateTime(),
    }],
    browserInformation: getBrowserInfo(),
    product: getProductWithLocale(product, plasticColor),
    identifiers: getIdentifiers(inAuthId),
    supplementaryApplicants: [removeEmptyFields({
      names: [
        getName({
          prefix,
          title,
          firstName,
          middleName,
          lastName,
        }),
      ],
      nameOnCard,
      dateOfBirth: formatDateOfBirth(dateOfBirth),
      emails: [
        {
          type: 'PERSONAL',
          emailID: email,
        },
      ],
      phones: [
        getPhone({
          phoneNumber: mobilePhoneNumber,
        }),
      ],
      hasSameAddressAsPrimary: hasSameAddress,
      companies: getCompanies({ profession, occupation, industry }),
      addresses: getSupplementaryAddress(),
      inhabitanceInformation: getInhabitance({
        nationality,
        placeOfBirth,
      }),
      cardTypeIndicator: productShortName === 'platinum' ? cardTypeIndicators[plasticColor] : cardTypeIndicators[plasticIndicators[0]],
    })],
    archiveBody: formattedArchiveData,
  });
};
